export default function ContactSection() {
  return (
    <section id="contact" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-mail-send-line"></i>
            联系我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            平台入驻 & 内容投稿
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            如果您是久久视频、芒果视频、97视频、丝瓜视频等在线视频平台的运营方，或希望推荐优质视频网站资源，欢迎通过以下方式与我们取得联系。青青草视频持续开放平台入驻与内容投稿通道，期待与更多视频网站合作。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-wechat-line text-primary-600 text-lg"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">微信联系</h3>
              <p className="text-xs text-foreground-500">添加官方微信账号</p>
            </div>
            <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-mail-line text-accent-600 text-lg"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">邮件投稿</h3>
              <p className="text-xs text-foreground-500">发送至官方邮箱</p>
            </div>
            <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-question-answer-line text-secondary-600 text-lg"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">在线留言</h3>
              <p className="text-xs text-foreground-500">提交合作意向表单</p>
            </div>
          </div>

          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50 border border-background-300 text-foreground-500 text-xs">
            <i className="ri-time-line"></i>
            工作日 9:00 - 18:00 在线回复
          </span>
        </div>
      </div>
    </section>
  );
}